import { render } from "./chart-alt-svg.vue?vue&type=template&id=48dc0bc8"
const script = {}

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__